import OrderPrintItem from "@@/core/components/order/OrderPrintItem/OrderPrintItem";
import Loading from "@@/core/components/shared/Loading/Loading";

export default {
  components: {
    OrderPrintItem,
    Loading,
  },
  data() {
    return {
      orders: null,
      settings: [],
    };
  },
  mounted() {
    if (this.$route.query) {
      this.getOrders(this.$route.query.ids);
      this.loadSettings();
    }
  },
  computed: {},
  methods: {
    async getOrders(ids) {
      let ordersId = ids.split(",");
      try {
        const response = await this.$axios.post("admin/orders/print/details", {
          ids: ordersId,
        });

        let orders = response.data.data.orders;
        orders.forEach((order) => {
          order.items.forEach((item) => {
            if (order.reserved == 1) {
              item.isReserved = false;
            }
            item.extra = JSON.parse(item.extra);
          });

          if (order.reserved == 1) {
            order.reservations.forEach((item) => {
              item.items.forEach((p) => {
                p.isReserved = true;
                p.extra = JSON.parse(p.extra);
                order.items.push(p);
              });
            });
          }
          return order;
        });
        orders.sort((a, b) => {
          return JSON.parse(a.address).city_id - JSON.parse(b.address).city_id;
        });
        this.orders = orders;
      } catch (error) {
        this.$root.notify(error);
      }
    },
    loadSettings() {
      this.$axios.get("admin/settings/shop_info").then((response) => {
        this.settings = response.data.data.settings;
      });
    },
  },
};
